import { render } from "./EnclosedDropdown.vue?vue&type=template&id=46f04fd2&scoped=true"
import script from "./EnclosedDropdown.vue?vue&type=script&lang=js"
export * from "./EnclosedDropdown.vue?vue&type=script&lang=js"

import "./EnclosedDropdown.vue?vue&type=style&index=0&id=46f04fd2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-46f04fd2"

export default script